Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.inputTypes = exports.defaultProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _airbnbI18n = require('airbnb-i18n');

var _airbnbI18n2 = _interopRequireDefault(_airbnbI18n);

var _AutoDirectionProvider = require('react-with-direction/dist/AutoDirectionProvider');

var _AutoDirectionProvider2 = _interopRequireDefault(_AutoDirectionProvider);

var _accessibilityLabel = require('../../utils/propTypes/accessibilityLabel');

var _accessibilityLabel2 = _interopRequireDefault(_accessibilityLabel);

var _autoCompleteTypes = require('../../constants/autoCompleteTypes');

var _autoCompleteTypes2 = _interopRequireDefault(_autoCompleteTypes);

var _idProp = require('../../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

var _inputTypes = require('../../constants/inputTypes');

var _inputTypes2 = _interopRequireDefault(_inputTypes);

var _placeholderStyle = require('../../utils/placeholderStyle');

var _placeholderStyle2 = _interopRequireDefault(_placeholderStyle);

var _visuallyHidden = require('../../utils/visuallyHidden');

var _visuallyHidden2 = _interopRequireDefault(_visuallyHidden);

var _IconClose = require('../../exp/icons/IconClose');

var _IconClose2 = _interopRequireDefault(_IconClose);

var _withStyles = require('../../themes/withStyles');

var _withBrand = require('../../themes/withBrand');

var _withBrand2 = _interopRequireDefault(_withBrand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  ampVarsInputName: _propTypes2['default'].string,
  autoCapitalize: _propTypes2['default'].oneOf(['none', 'sentences', 'words', 'characters']),
  autoComplete: (0, _airbnbPropTypes.or)([_propTypes2['default'].oneOf(['on', 'off']), _propTypes2['default'].arrayOf((0, _airbnbPropTypes.or)([_propTypes2['default'].oneOf(_autoCompleteTypes2['default']), (0, _airbnbPropTypes.stringStartsWith)('section-')], 'list of (valid categories or section-*)'))], 'on/off, or list of (valid categories or section-*)'),
  autoCorrect: _propTypes2['default'].bool,
  autoFocus: _propTypes2['default'].bool,
  book: _propTypes2['default'].bool,
  borderless: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  errorMessageID: _idProp2['default'],
  focusBorderless: _propTypes2['default'].bool,
  inputRef: _propTypes2['default'].func,
  invalid: _propTypes2['default'].bool,
  inverse: _propTypes2['default'].bool,
  large: _propTypes2['default'].bool,
  maxLength: (0, _airbnbPropTypes.integer)(),
  id: _propTypes2['default'].string.isRequired,
  inline: _propTypes2['default'].bool,
  name: _propTypes2['default'].string.isRequired,
  onBlur: _propTypes2['default'].func,
  onChange: _propTypes2['default'].func,
  onClear: _propTypes2['default'].func,
  onFocus: _propTypes2['default'].func,
  onKeyDown: _propTypes2['default'].func,
  placeholder: _accessibilityLabel2['default'],
  prefix: _propTypes2['default'].node,
  readOnly: _propTypes2['default'].bool,
  refForFocus: _propTypes2['default'].func,
  removeMargins: _propTypes2['default'].bool,
  role: _propTypes2['default'].string,
  showFakeValuePlaceholder: _propTypes2['default'].bool,
  showOverflowEllipsis: _propTypes2['default'].bool,
  small: _propTypes2['default'].bool,
  spellCheck: _propTypes2['default'].bool,
  suffix: _propTypes2['default'].node,
  suffixText: _propTypes2['default'].node,
  type: _propTypes2['default'].oneOf(Object.values(_inputTypes2['default'])),
  underlineFocus: _propTypes2['default'].bool,
  value: _propTypes2['default'].string,
  velouteId: _propTypes2['default'].string,
  // a11y
  'aria-owns': _propTypes2['default'].string
};

var finalPropTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, propTypes, {
  brand: _withBrand.requiredBrandPropType
}));

var defaultProps = exports.defaultProps = {
  ampVarsInputName: undefined,
  autoCapitalize: null,
  autoComplete: null,
  autoCorrect: null,
  autoFocus: false,
  book: false,
  borderless: false,
  disabled: false,
  errorMessageID: undefined,
  focusBorderless: false,
  inputRef: function () {
    function inputRef() {}

    return inputRef;
  }(),

  invalid: false,
  inverse: false,
  inline: false,
  large: false,
  maxLength: null,
  onBlur: function () {
    function onBlur() {}

    return onBlur;
  }(),
  onChange: function () {
    function onChange() {}

    return onChange;
  }(),

  onClear: null,
  onFocus: function () {
    function onFocus() {}

    return onFocus;
  }(),
  onKeyDown: function () {
    function onKeyDown() {}

    return onKeyDown;
  }(),

  prefix: null,
  readOnly: false,
  refForFocus: function () {
    function refForFocus() {}

    return refForFocus;
  }(),

  removeMargins: false,
  showFakeValuePlaceholder: false,
  showOverflowEllipsis: false,
  small: false,
  spellCheck: null,
  suffix: null,
  suffixText: null,
  type: _inputTypes2['default'].TEXT,
  underlineFocus: false,
  value: '',
  velouteId: undefined
};

var InputOnly = function (_React$Component) {
  _inherits(InputOnly, _React$Component);

  function InputOnly(props) {
    _classCallCheck(this, InputOnly);

    var _this = _possibleConstructorReturn(this, (InputOnly.__proto__ || Object.getPrototypeOf(InputOnly)).call(this, props));

    _this.state = {
      isFocused: false,
      measuredContentWidth: -1
    };

    _this.onBlur = _this.onBlur.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onClear = _this.onClear.bind(_this);
    _this.prepareToClear = _this.prepareToClear.bind(_this);
    _this.onInputBlur = _this.onInputBlur.bind(_this);
    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.setInputRef = _this.setInputRef.bind(_this);

    _this.isGoingToClear = false;
    return _this;
  }

  _createClass(InputOnly, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        var suffixText = this.props.suffixText;

        if (suffixText) {
          this.updateMeasuredContentWidth();
          this.updateMeasuredContentTimeout = setTimeout(function () {
            _this2.updateMeasuredContentWidth();
          }, 0);
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var _props = this.props,
            suffixText = _props.suffixText,
            value = _props.value;

        if (suffixText && prevProps.value !== value) {
          this.updateMeasuredContentWidth();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        clearTimeout(this.updateMeasuredContentTimeout);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onBlur',
    value: function () {
      function onBlur() {
        this.setState({
          isFocused: false
        });
      }

      return onBlur;
    }()
  }, {
    key: 'onFocus',
    value: function () {
      function onFocus() {
        this.setState({
          isFocused: true
        });
      }

      return onFocus;
    }()
  }, {
    key: 'onClear',
    value: function () {
      function onClear(e) {
        var onClear = this.props.onClear;

        this.inputRef.focus();
        onClear(e);
      }

      return onClear;
    }()
  }, {
    key: 'onInputBlur',
    value: function () {
      function onInputBlur(e) {
        var onBlur = this.props.onBlur;

        onBlur(e);
        if (this.isGoingToClear) {
          // we call stopPropagation to prevent the onBlur event bubbling up
          //  This prevents the onBlur on the div wrapper to fire
          //  allowing onMouseUp and onClick to work on Safari and Firefox
          e.stopPropagation();
          this.isGoingToClear = false;
        }
      }

      return onInputBlur;
    }()
  }, {
    key: 'onInputChange',
    value: function () {
      function onInputChange(e) {
        var onChange = this.props.onChange;

        onChange(e.target.value);
      }

      return onInputChange;
    }()
  }, {
    key: 'setInputRef',
    value: function () {
      function setInputRef(ref) {
        this.inputRef = ref;

        var _props2 = this.props,
            inputRef = _props2.inputRef,
            refForFocus = _props2.refForFocus;

        inputRef(ref);
        refForFocus(ref);
      }

      return setInputRef;
    }()
  }, {
    key: 'prepareToClear',
    value: function () {
      function prepareToClear() {
        // In some browsers, clicking on a button won't trigger a focus event.
        // This makes it so that when the user tries to click on the clear button,
        // it blurs the input and hides the clear button before the click event can continue.
        // To avoid that problem, we're tracking whether the user intends to clear the input
        //  so that we can avoid hiding the clear button before the click event fires.
        this.isGoingToClear = true;
      }

      return prepareToClear;
    }()

    // Measures width of Input's content to position suffixText correctly

  }, {
    key: 'updateMeasuredContentWidth',
    value: function () {
      function updateMeasuredContentWidth() {
        if (this.contentMeasurer) {
          var contentWidth = this.contentMeasurer.getBoundingClientRect().width;
          this.setState({
            measuredContentWidth: contentWidth
          });
        }
      }

      return updateMeasuredContentWidth;
    }()
  }, {
    key: 'suffixTextStyles',
    value: function () {
      function suffixTextStyles() {
        var measuredContentWidth = this.state.measuredContentWidth;

        return {
          left: measuredContentWidth,
          // suffixText should be hidden unless content measurement is performed
          visibility: measuredContentWidth >= 0 ? 'visible' : 'hidden'
        };
      }

      return suffixTextStyles;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var _props3 = this.props,
            css = _props3.css,
            ampVarsInputName = _props3.ampVarsInputName,
            ariaOwns = _props3['aria-owns'],
            autoCapitalize = _props3.autoCapitalize,
            autoComplete = _props3.autoComplete,
            autoCorrect = _props3.autoCorrect,
            autoFocus = _props3.autoFocus,
            book = _props3.book,
            borderless = _props3.borderless,
            brand = _props3.brand,
            disabled = _props3.disabled,
            errorMessageID = _props3.errorMessageID,
            focusBorderless = _props3.focusBorderless,
            id = _props3.id,
            inline = _props3.inline,
            invalid = _props3.invalid,
            inverse = _props3.inverse,
            large = _props3.large,
            maxLength = _props3.maxLength,
            name = _props3.name,
            onClear = _props3.onClear,
            onFocus = _props3.onFocus,
            onKeyDown = _props3.onKeyDown,
            placeholder = _props3.placeholder,
            prefix = _props3.prefix,
            readOnly = _props3.readOnly,
            removeMargins = _props3.removeMargins,
            role = _props3.role,
            showFakeValuePlaceholder = _props3.showFakeValuePlaceholder,
            showOverflowEllipsis = _props3.showOverflowEllipsis,
            small = _props3.small,
            spellCheck = _props3.spellCheck,
            styles = _props3.styles,
            suffix = _props3.suffix,
            suffixText = _props3.suffixText,
            type = _props3.type,
            underlineFocus = _props3.underlineFocus,
            value = _props3.value,
            velouteId = _props3.velouteId;
        var isFocused = this.state.isFocused;

        var isSelectBrand = brand === _withBrand.BRAND_SELECT;

        var autoCapitalizeProps = autoCapitalize && { autoCapitalize: autoCapitalize } || {};
        var autoCorrectProps = autoCorrect === true && { autoCorrect: 'on' } || autoCorrect === false && { autoCorrect: 'off' } || {};
        var spellCheckProps = spellCheck === true && { spellCheck: 'true' } || spellCheck === false && { spellCheck: 'false' } || {};

        return _react2['default'].createElement(
          _AutoDirectionProvider2['default'],
          {
            inline: inline,
            text: value || ''
          },
          _react2['default'].createElement(
            'div',
            _extends({
              onBlur: this.onBlur,
              onFocus: this.onFocus
            }, css(styles.container, removeMargins && styles.container_noMargins, small && styles.container_small, inverse && styles.container_inverse, borderless && !isFocused && styles.borderless, inverse && borderless && styles.container_inverseBorderless, !inline && styles.block, isFocused && styles.focus, isFocused && isSelectBrand && styles.focus_select, isFocused && underlineFocus && !focusBorderless && styles.focus_underline, isFocused && focusBorderless && styles.focus_borderless, invalid && styles.invalid, disabled && styles.container_disabled)),
            !!prefix && _react2['default'].createElement(
              'div',
              css(styles.prefixContainer),
              _react2['default'].createElement(
                'div',
                css(styles.prefix, large && styles.prefix_large, small && styles.prefix_small),
                prefix
              )
            ),
            !!suffix && _react2['default'].createElement(
              'div',
              css(styles.suffixContainer),
              _react2['default'].createElement(
                'div',
                css(styles.suffix, large && styles.suffix_large, small && styles.suffix_small),
                suffix
              )
            ),
            _react2['default'].createElement(
              'div',
              css(styles.inputContainer),
              _react2['default'].createElement('input', _extends({}, invalid && { 'aria-invalid': 'true' }, {
                autoComplete: autoComplete && [].concat(autoComplete).join(' '),
                autoFocus: autoFocus,
                'aria-describedby': invalid ? errorMessageID : null,
                'aria-owns': ariaOwns
              }, css(styles.input, small && styles.input_small, book && styles.input_book, large && styles.input_large, showOverflowEllipsis && styles.input_ellipsis, showFakeValuePlaceholder ? styles.input_fakeValuePlaceholder : styles.input_defaultPlaceholder, inverse && styles.textInverse, inverse && styles.placeholderInverse), {
                'data-veloute': velouteId,
                'data-vars-input-name': ampVarsInputName,
                disabled: disabled,
                readOnly: readOnly,
                ref: this.setInputRef,
                id: id,
                maxLength: maxLength,
                name: name,
                onBlur: this.onInputBlur,
                onChange: this.onInputChange,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                placeholder: placeholder,
                role: role,
                value: value,
                type: type
              }, autoCapitalizeProps, autoCorrectProps, spellCheckProps)),
              suffixText && _react2['default'].createElement(
                'div',
                css(styles.suffixTextContainer),
                _react2['default'].createElement(
                  'span',
                  css(styles.input, small && styles.input_small, large && styles.input_large, styles.suffixText, this.suffixTextStyles(), inverse && styles.textInverse),
                  suffixText
                ),
                _react2['default'].createElement(
                  'span',
                  _extends({
                    ref: function () {
                      function ref(elt) {
                        _this3.contentMeasurer = elt;
                      }

                      return ref;
                    }()
                  }, css(styles.input, small && styles.input_small, styles.contentMeasurer)),
                  value || placeholder
                )
              ),
              onClear && value.length > 0 && _react2['default'].createElement(
                'div',
                _extends({
                  'data-veloute': String(velouteId) + '__clearButton'
                }, css(styles.clearInputBtnWrapper, !isFocused && styles.clearInputBtnWrapper_hidden)),
                _react2['default'].createElement(
                  'div',
                  css(styles.vertMiddle),
                  _react2['default'].createElement(
                    'button',
                    _extends({}, css(styles.clearInputBtn, small && styles.clearInputBtn_small, large && styles.clearInputBtn_large, inverse && styles.textInverse), {
                      onClick: this.onClear,
                      onMouseDown: this.prepareToClear,
                      onTouchStart: this.prepareToClear,
                      type: 'button'
                    }),
                    _react2['default'].createElement(_IconClose2['default'], {
                      size: 12,
                      accessibilityLabel: _airbnbI18n2['default'].t('Shared.clearInput', { 'default': 'Clear Input' })
                    })
                  )
                )
              )
            ),
            underlineFocus && isFocused && _react2['default'].createElement('div', css(styles.focusUnderline, isSelectBrand && styles.focusUnderlineColor_select))
          )
        );
      }

      return render;
    }()
  }]);

  return InputOnly;
}(_react2['default'].Component);

InputOnly.componentCategory = 'Private';
InputOnly.displayName = 'InputOnly';


InputOnly.propTypes = finalPropTypes;
InputOnly.defaultProps = defaultProps;

var borderWidth = 1;

exports['default'] = (0, _withBrand2['default'])((0, _withStyles.withStyles)(function (_ref) {
  var unit = _ref.unit,
      color = _ref.color,
      font = _ref.font;

  var basePaddingSmall = unit;
  var basePadding = 1.5 * unit;
  var basePaddingLarge = 2 * unit;

  return {
    container: Object.assign({}, font.formInput, {
      borderWidth: borderWidth,
      borderStyle: 'solid',
      borderColor: color.inputBorder,
      borderRadius: unit / 4,
      backgroundColor: color.inputBackground,
      marginBottom: 1 * unit,
      position: 'relative',
      zIndex: 0 // To position suffixTextContainer underneath the input
    }),

    container_disabled: {
      backgroundColor: color.inputDisabled
    },

    container_noMargins: {
      // written individually to overwrite existing values
      marginBottom: 0,
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0
    },

    container_small: Object.assign({}, font.textSmall),

    container_inverse: {
      backgroundColor: 'transparent'
    },

    container_inverseBorderless: {
      borderColor: 'transparent'
    },

    textInverse: {
      color: color.white
    },

    block: {
      display: 'block',
      width: '100%'
    },

    borderless: {
      // use the background color as the border color to appear borderless while preserving size
      borderColor: color.inputBackground
    },

    focus: {
      borderWidth: borderWidth,
      borderStyle: 'solid',
      borderColor: color.inputFocusedBorder
    },

    focus_select: {
      borderColor: color.core.hackberry
    },

    focus_underline: {
      // use the background color as the border color to appear borderless while preserving size
      borderColor: color.inputBorder
    },

    focus_borderless: {
      // use the background color as the border color to appear borderless while preserving size
      borderColor: color.inputBackground
    },

    focusUnderline: {
      // -1 to offset the border inputBackground border color
      left: -1,
      right: -1,
      bottom: -1,
      position: 'absolute',
      height: 2,
      background: color.inputFocusedUnderlineBorder
    },

    focusUnderlineColor_select: {
      background: color.core.hackberry
    },

    prefixContainer: {
      float: 'left'
    },

    prefix: Object.assign({}, font.book, {
      paddingLeft: basePadding,
      paddingTop: basePadding - borderWidth
    }),

    prefix_large: Object.assign({}, font.textLarge, {
      paddingLeft: basePaddingLarge,
      paddingTop: basePaddingLarge - borderWidth
    }),

    prefix_small: Object.assign({}, font.textSmall, {
      paddingLeft: basePaddingSmall,
      paddingTop: basePaddingSmall - borderWidth
    }),

    suffixContainer: {
      float: 'right'
    },

    suffix: {
      paddingRight: basePadding,
      paddingTop: basePadding - borderWidth
    },

    suffix_large: Object.assign({}, font.textLarge, {
      paddingRight: basePaddingLarge,
      paddingTop: basePaddingLarge - borderWidth
    }),

    suffix_small: Object.assign({}, font.textSmall, {
      paddingRight: basePaddingSmall,
      paddingTop: basePaddingSmall - borderWidth
    }),

    suffixTextContainer: {
      bottom: 0,
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: -1 // We want it under the input because IE9 does not support pointerEvents
    },

    suffixText: {
      color: color.placeholder,
      position: 'absolute',
      whiteSpace: 'nowrap',
      transform: 'translateX(' + -1.5 * unit + 'px)'
    },

    contentMeasurer: {
      border: 0,
      display: 'inline',
      position: 'absolute',
      top: 0,
      transform: 'translateY(-100px)',
      whiteSpace: 'pre',
      width: 'auto'
    },

    inputContainer: {
      overflow: 'hidden',
      position: 'relative'
    },

    input: Object.assign({}, font.formInput, font.light, {
      backgroundColor: color.clear,
      border: 0,
      padding: basePadding - borderWidth,
      width: '100%',

      ':focus': {
        outline: 'none'
      },

      '::-ms-clear': {
        display: 'none'
      }
    }),

    input_defaultPlaceholder: (0, _placeholderStyle2['default'])({
      color: color.placeholder,
      opacity: 1
    }),

    input_small: Object.assign({}, font.textSmall, font.book, {
      padding: basePaddingSmall - borderWidth
    }),

    input_large: Object.assign({}, font.textLarge, {
      padding: basePaddingLarge - borderWidth
    }),

    input_book: Object.assign({}, font.book),

    input_ellipsis: {
      textOverflow: 'ellipsis'
    },

    input_fakeValuePlaceholder: (0, _placeholderStyle2['default'])({
      color: font.formInput.color,
      opacity: 1
    }),

    placeholderInverse: (0, _placeholderStyle2['default'])({
      color: color.white
    }),

    invalid: {
      backgroundColor: color.inputInvalidBackground,
      border: borderWidth + 'px solid ' + String(color.inputInvalidBorder),

      ':focus': {
        border: borderWidth + 'px solid ' + String(color.inputInvalidBorder)
      }
    },

    clearInputBtnWrapper: {
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      height: '100%',

      // vertical alignment for children
      ':before': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%'
      }
    },

    clearInputBtnWrapper_hidden: Object.assign({}, _visuallyHidden2['default']),

    vertMiddle: {
      verticalAlign: 'middle',
      display: 'inline-block'
    },

    clearInputBtn: {
      color: color.placeholder,
      cursor: 'pointer',
      background: 'transparent',
      border: 0,
      padding: basePadding,

      ':active': {
        outline: 0
      }
    },

    clearInputBtn_small: {
      padding: basePaddingSmall
    },

    clearInputBtn_large: {
      padding: basePaddingLarge
    }
  };
})(InputOnly));
exports.inputTypes = _inputTypes2['default'];
exports.propTypes = propTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/Forms/InputOnly.js
// module id = 430
// module chunks = 923280921217